// extracted by mini-css-extract-plugin
export default {"container":"settings_container__BFBo1","wrapper":"settings_wrapper__HyRn8","tabs":"settings_tabs__IEyAZ"};